import BaseProxy from './BaseProxy'
import axios from 'axios'

export class MonitoringProxy extends BaseProxy {
  constructor() {
    super()
    this._baseUrl = `${this._baseUrl}/api/monitoring`
  }

  async getSummary(hours, top) {
    const response = await axios.get(
      `${this._baseUrl}/summary${this._makeUrlParams({ hours, top })}`
    )
    return response.data
  }
}

export default MonitoringProxy
